export default {"src":"/frontend-static/_next/static/media/visaLight.15445bdb.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};